'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.deepMap = deepMap;
exports.deepForEach = deepForEach;

var _react = require('react');

var _Tab = require('../Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _TabList = require('../TabList');

var _TabList2 = _interopRequireDefault(_TabList);

var _TabPanel = require('../TabPanel');

var _TabPanel2 = _interopRequireDefault(_TabPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isTabChild(child) {
    return child.type === _Tab2.default || child.type === _TabList2.default || child.type === _TabPanel2.default;
}
function deepMap(children, callback) {
    return _react.Children.map(children, function (child) {
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if (isTabChild(child)) {
            return callback(child);
        }
        if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
            // Clone the child that has children and map them too
            return (0, _react.cloneElement)(child, Object.assign({}, child.props, { children: deepMap(child.props.children, callback) }));
        }
        return child;
    });
}
function deepForEach(children, callback) {
    return _react.Children.forEach(children, function (child) {
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if (child.type === _Tab2.default || child.type === _TabPanel2.default) {
            callback(child);
        } else if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
            if (child.type === _TabList2.default) callback(child);
            deepForEach(child.props.children, callback);
        }
    });
}
//# sourceMappingURL=childrenDeepMap.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tabs/helpers/childrenDeepMap.js